document.addEventListener('DOMContentLoaded', () => {
  const flyout = document.getElementById('gpi-cart-flyout');
  const overlay = document.getElementById('gpi-cart-overlay');
  const cartContent = document.getElementById('gpi-cart-content');
  const closeBtn = flyout.querySelector('.gpi-cart-flyout__close');
  const subtotalLabel = document.getElementById('gpi-cart-subtotal-label');
  const subtotalAmount = document.getElementById('gpi-cart-subtotal-amount');
  const checkoutButton = flyout.querySelector('.gpi-cart-flyout__checkout-button');
  const continueButton = flyout.querySelector('.gpi-cart-flyout__continue-button');
  const recommendationsContainer = document.getElementById('gpi-cart-recommendations');

  const fallbackProductHandle = 'roland-premium-reflective-vinyl-permanent-adhesive';

  const formatPrice = (cents) => {
    const dollars = cents / 100;
    return dollars.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const updateCart = (line, quantity) => {
    const itemEl = cartContent.querySelector(`.gpi-cart-item[data-line="${line}"]`);
    if (itemEl) {
      const quantitySpan = itemEl.querySelector('span');
      const priceEl = itemEl.querySelector('.gpi-cart-item__price');
      const unitPrice = parseFloat(priceEl.dataset.unitPrice);
      if (quantity > 0) {
        quantitySpan.textContent = quantity;
        priceEl.textContent = formatPrice(quantity * unitPrice * 100);
      }
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    })
    .then(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          subtotalLabel.textContent = `Subtotal (${cart.item_count} items)`;
          subtotalAmount.textContent = formatPrice(cart.total_price);

          // Only re-open cart UI if item was removed
          if (quantity === 0) openCart();
        });
    });
  };

  const addToCart = (variantId) => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(() => {
      openCart();
    })
    .catch(error => console.error('Error adding item to cart:', error));
  };

  const renderRecommendation = (product) => {
    const variants = (product.variants || []).filter(v => v.available);
    if (!variants.length || !product.available) return false;
    const firstVariant = variants[0];

    const imageSrc = firstVariant.featured_image?.src || product.featured_image?.src || product.images?.[0]?.src;
    if (!imageSrc) return false;

    const showSelect = variants.length > 1 || firstVariant.title !== 'Default Title';
    const optionsHtml = showSelect ? `<select class="gpi-recommendation-item__variants">${variants.map(variant => `<option value="${variant.id}">${variant.title}</option>`).join('')}</select>` : '';

    const productHtml = `
      <div class="gpi-recommendation-item">
        <div class="gpi-recommendation-item__image-wrapper">
          <img src="${imageSrc}" alt="${product.title}" class="gpi-recommendation-item__image" />
        </div>
        <div class="gpi-recommendation-item__details">
          <p class="gpi-recommendation-item__title">${product.title}</p>
          <p class="gpi-recommendation-item__price">${formatPrice(firstVariant.price)}</p>
          ${optionsHtml}
          <button class="gpi-recommendation-item__add-button">Add</button>
        </div>
      </div>
    `;

    recommendationsContainer.innerHTML = '<h3 class="gpi-recommendation-heading">Customers also bought</h3>';
    recommendationsContainer.insertAdjacentHTML('beforeend', productHtml);
    return true;
  };

  const fetchAndRenderRecommendations = (productId) => {
    fetch(`/recommendations/products.json?product_id=${productId}&intent=related&limit=1`)
      .then(res => res.json())
      .then(data => {
        recommendationsContainer.innerHTML = '<h3 class="gpi-recommendation-heading">Customers also bought</h3>';
        if (data.products && data.products.length > 0) {
          const valid = data.products.find(p => p.available && p.variants?.some(v => v.available));
          if (valid && renderRecommendation(valid)) {
            attachVariantListeners();
            return;
          }
        }
        fetchAndRenderFallback();
      })
      .catch(() => fetchAndRenderFallback());
  };

  const fetchAndRenderFallback = () => {
    fetch(`/products/${fallbackProductHandle}.js`)
      .then(res => res.json())
      .then(product => {
        if (renderRecommendation(product)) {
          attachVariantListeners();
        } else {
          fetch('/products.json')
            .then(res => res.json())
            .then(allProducts => {
              const random = allProducts.products.find(p => p.available && p.variants?.some(v => v.available));
              if (random && renderRecommendation(random)) {
                attachVariantListeners();
              }
            });
        }
      });
  };

  const attachVariantListeners = () => {
    document.querySelectorAll('.gpi-recommendation-item__add-button').forEach(button => {
      button.addEventListener('click', (e) => {
        const container = e.target.closest('.gpi-recommendation-item__details');
        const select = container.querySelector('.gpi-recommendation-item__variants');
        const selectedVariantId = select ? select.value : null;
        if (selectedVariantId) {
          addToCart(selectedVariantId);
        }
      });
    });

    document.querySelectorAll('.add-to-cart').forEach(button => {
      button.addEventListener('click', (e) => {
        const variantId = button.getAttribute('data-id');
        if (variantId) addToCart(variantId);
      });
    });

    document.querySelectorAll('.variant-selector').forEach(selector => {
      selector.addEventListener('change', (e) => {
        const newVariantId = e.target.value;
        const wrapper = e.target.closest('.recommendation-item');
        const addBtn = wrapper.querySelector('.add-to-cart');
        if (addBtn && newVariantId) {
          addBtn.setAttribute('data-id', newVariantId);
        }
      });
    });
  };

  const openCart = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const items = cart.items.map((item, index) => `
          <div class="gpi-cart-item" data-line="${index + 1}">
            <img src="${item.image}" alt="${item.title}" class="gpi-cart-item__image" />
            <div class="gpi-cart-item__details">
              <p class="gpi-cart-item__title"><a href="${item.url}">${item.title}</a></p>
              <div class="gpi-cart-item__quantity">
                <button class="quantity-decrease">-</button>
                <span>${item.quantity}</span>
                <button class="quantity-increase">+</button>
              </div>
            </div>
            <div class="gpi-cart-item__meta">
              <div class="gpi-cart-item__price" data-unit-price="${(item.price / 100).toFixed(2)}">
                ${formatPrice(item.quantity * item.price)}
              </div>
              <button class="gpi-cart-item__remove" aria-label="Remove item" title="Remove item" data-line="${index + 1}">🗑️</button>
            </div>
          </div>
        `).join('');

        cartContent.innerHTML = items || '<p>Your cart is empty.</p>';
        subtotalLabel.textContent = `Subtotal (${cart.item_count} items)`;
        subtotalAmount.textContent = formatPrice(cart.total_price);

        if (cart.items.length > 0) {
          const uniqueProductId = cart.items[0]?.product_id;
          if (uniqueProductId) {
            fetchAndRenderRecommendations(uniqueProductId);
          }
        } else {
          fetchAndRenderFallback();
        }

        flyout.classList.add('open');
        overlay.classList.add('visible');
        document.body.classList.add('cart-open');

        cartContent.querySelectorAll('.gpi-cart-item').forEach(itemEl => {
          const line = parseInt(itemEl.getAttribute('data-line'));
          const quantitySpan = itemEl.querySelector('span');
          const decreaseBtn = itemEl.querySelector('.quantity-decrease');
          const increaseBtn = itemEl.querySelector('.quantity-increase');
          const removeBtn = itemEl.querySelector('.gpi-cart-item__remove');

          decreaseBtn.addEventListener('click', () => {
            const currentQty = parseInt(quantitySpan.textContent);
            if (currentQty > 1) {
              updateCart(line, currentQty - 1);
            }
          });

          increaseBtn.addEventListener('click', () => {
            const currentQty = parseInt(quantitySpan.textContent);
            updateCart(line, currentQty + 1);
          });

          removeBtn.addEventListener('click', () => {
            updateCart(line, 0);
          });
        });
      });
  };

  const closeCart = () => {
    flyout.classList.remove('open');
    overlay.classList.remove('visible');
    document.body.classList.remove('cart-open');
  };

  document.querySelectorAll('a[href="/cart"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      openCart();
    });
  });

  closeBtn.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);

  checkoutButton.addEventListener('click', () => {
    window.location.href = '/checkout';
  });

  continueButton.addEventListener('click', () => {
    closeCart();
  });

  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
      .then(res => res.json())
      .then(() => {
        openCart();
      })
      .catch(error => console.error('Error adding item to cart:', error));
    });
  });

  // Theme extension support
  window.addEventListener('click', function (e) {
    if (e.target.matches('.add-to-cart')) {
      const variantId = e.target.dataset.id;
      if (variantId) addToCart(variantId);
    }
  });

  window.addEventListener('change', function (e) {
    if (e.target.matches('.variant-selector')) {
      const selectedVariant = e.target.value;
      const container = e.target.closest('.recommendation-item');
      const button = container?.querySelector('.add-to-cart');
      if (button) button.setAttribute('data-id', selectedVariant);
    }
  });
});
